/**
 * @license
 * Powered by MaxDesign. All Rights Reserved.
 * ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
 * ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
 */

if (!customElements.get('delivery-estimation-maxdesign')) {
  class DeliveryEstimation extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      setTimeout(() => {
        this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
        this.placeholder = this.querySelector('[data-delivery-estimation]');
        this.renderResult(this.getDays());
        if (this.settings.geoFlagEnable && this.settings.geoFlagAPI != '') this.geoFlag();
      }, 1);
    }

    renderResult({ dayMin, monthMin, dayMax, monthMax }) {
      const deliveryText = this.placeholder.innerHTML;
      this.placeholder.innerHTML = deliveryText
        .replace('[dayMin]', dayMin)
        .replace('[dayMax]', dayMax)
        .replace('[monthMin]', monthMin === monthMax ? '' : monthMin)
        .replace('[monthMax]', monthMax);
    }

    getBrusselsStartDate() {
      const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Brussels',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        hourCycle: 'h23',
      })
        .formatToParts(new Date())
        .reduce((values, part) => {
          if (part.type !== 'literal') values[part.type] = part.value;
          return values;
        }, {});

      const startDate = new Date(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day)
      );

      const cutoffReached = Number(parts.hour) >= 14;

      if (cutoffReached || !this.isBusinessDay(startDate)) {
        do {
          startDate.setDate(startDate.getDate() + 1);
        } while (!this.isBusinessDay(startDate));
      }

      return startDate;
    }

    isBusinessDay(date) {
      const weekday = date.getDay();
      return weekday !== 0 && weekday !== 1 && weekday !== 6 && this.checkHolidays(date);
    }

    addBusinessDays(startDate, days) {
      const date = new Date(startDate);
      let count = 0;

      while (count < days) {
        date.setDate(date.getDate() + 1);
        if (this.isBusinessDay(date)) count++;
      }

      return date;
    }

    getDays() {
      const deliveryTag = this.placeholder.dataset.deliveryEstimation;
      const monthNames = this.settings.monthNames.split(',');
      const startDate = this.getBrusselsStartDate();
      const endDateMin = this.addBusinessDays(startDate, this.settings[deliveryTag].min);
      const endDateMax = this.addBusinessDays(startDate, this.settings[deliveryTag].max);

      return {
        dayMin: endDateMin.getDate(),
        monthMin: monthNames[endDateMin.getMonth()],
        dayMax: endDateMax.getDate(),
        monthMax: monthNames[endDateMax.getMonth()],
      };
    }

    /**
     * check whether  holiday match
     * @param {Date} dateIncrement
     * @returns {Boolean}
     */
    checkHolidays(dateIncrement) {
      for (const [index, i] of Object.entries(this.settings.holidays))
        if (i[0] == dateIncrement.getDate() && i[1] == dateIncrement.getMonth() + 1) return;
      return true;
    }

    geoFlag() {
      fetch(`https://api.ipdata.co/?api-key=${this.settings.geoFlagAPI}`)
        .then(response => response.json())
        .then(geoData => {
          if (this.settings.geoFlagCountries.includes(geoData.country_code))
            this.querySelector('[data-delivery-flag]').innerHTML = `<img src="${geoData.flag}">`;
        })
        .catch(console.error);
    }
  }
  customElements.define('delivery-estimation-maxdesign', DeliveryEstimation);
}
